import { useState } from "react";
import getInitials from "../../Utils/getInitials";

const sizeClasses = {
  xs: "w-6 h-6 text-xs",  // 24px
  sm: "w-8 h-8 text-sm",  // 32px
  md: "w-10 h-10 text-base", // 40px (default)
  lg: "w-12 h-12 text-lg",  // 48px
  xl: "w-16 h-16 text-xl",  // 64px
};

const ProfilePhoto = ({ src, alt, firstName, lastName, size= "md" }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);

  const initials = getInitials(`${firstName} ${lastName}`);
  const sizeClass = sizeClasses[size] || sizeClasses.md;

  return (
    <div className={`relative ${sizeClass} rounded-full overflow-hidden flex items-center justify-center bg-slate-500 text-white font-semibold`}>
      {/* Initials as fallback */}
      {(!src || hasError || !isLoaded) && initials}

      {src && !hasError && (
        <img
          src={src}
          alt={alt}
          className={`${sizeClass} rounded-full object-cover absolute inset-0 transition-opacity duration-200 ${
            isLoaded ? "opacity-100" : "opacity-0"
          }`}
          onLoad={() => setIsLoaded(true)}
          onError={() => setHasError(true)}
        />
      )}
    </div>
  );
};

export default ProfilePhoto;
